<template>
  <div>
    <Head title="Create Sku" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sku-items/">SKU Items</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <!--
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-3/4" label=" Name" />
          
          <div class="flex flex-wrap -mb-8 -mr-6 p-8 w-full lg:w-1/4">
            <ol>
              <li v-for="item in items" :key="item.id" class="list-decimal">{{ item.name }}</li>
            </ol>
          </div> -->
          <text-input v-model="form.quantity" :error="form.errors.quantity" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Pieces" placeholder="Pieces" />
          <div class="pb-8 pr-6 w w-1/2 lg:w-1/2">
            <p class="mb-2">SKU:</p>
            <multiselect
              id="part_number"
              v-model="selectedSku"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.part_number"
              :style="form.errors.part_number ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchSkusChange"
              @input="onSelectedSku"
            />
            <div v-if="form.errors.part_number" class="form-error">{{ form.errors.part_number }}</div>
          </div>
          <!--
          <select-input v-model="form.part_number" :error="form.errors.part_number" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Part Number">
            <option :value="null">
              Select the part number
            </option>
            <option
              v-for="(item) in skus"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select-input>
          -->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Generate UIDs</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    sku: Object,
    items: Object,
    skus: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        quantity: '',
        part_number: '',
        job_card_number: '',
      }),
      selectedSku: null,
    }
  },
  methods: {
    store() {
      this.msgSuccess = ''
      this.form.post('/items', {
        onSuccess: () => {
          this.form.reset('name'),
          window.location.href = '/item-downloads'
        },
      })
      
    },
    onSearchSkusChange: throttle(function (search) {
      this.$inertia.get('/items/manufacturing/generate-uids/create', {search}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
    onSelectedSku(part_number, id) {
      this.form.part_number = part_number
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
